module.exports = __webpack_public_path__ + "img/SKWINKELNetActieCampagnematerialenCA526C.5186a408.png";